import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LeaderboardComponent from './js/leaderboard.component';

ComponentsFactory.getInstance().define('leaderboard', LeaderboardComponent);

export * from './js/components/sortingStrategies';
